import React from 'react';

interface MessageContainerProps {
  children: React.ReactNode;
}

// Simple container component for centered message displays
const MessageContainer: React.FC<MessageContainerProps> = ({ children }) => (
  <div className="container mx-auto px-4 py-8 max-w-6xl">
    <div className="bg-white rounded-lg shadow-lg p-8 text-center">
      {children}
    </div>
  </div>
);

export default MessageContainer;
